'use client';
import { BUTTON_TYPE } from '@/components/product/const';
import { AddCart, reserveReq, takeCouponReq } from '@/apis/dp/service';
import UKToast from '@/components/UKToast';
import { useTranslation } from '@/i18n/client';
import { LoginCallBackType, callAfterLoginByUrl } from '@/lib/jdiClientUtils';
import { useStores } from '@/models';
import { BuyOrAddToCarWrapper, ReserveTipsWrapper } from '@/styles/product';
import { sendClickTrack } from '@/tracks/25217';
import { addCartUtil } from '@/utils/cartUtils';
import cookieUtil from '@/intl-jdi-common-ssr/utils/cookieUtils';
import { DP_EVENT_NAMES, dpBusinessLogger } from '@/utils/dpUtils/businessLogger';
import OutOfStackController from '@/utils/outofStock/outofStockController';
import { gtagAddCartLog } from '@/intl-jdi-common-ssr/utils/thirdParty/gtag';
import { getUserUUIDFromCookie } from '@/utils/userUtils';
import { observer } from 'mobx-react-lite';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import BottomButtonLayout, { BtnEventIds } from './bottomButtonLayout';
import { Countdown } from './brandLaunch';
import ChooseDelivery from './chooseDelivery';
import DpCounter from './dpCounter';
import ServiceController from './serviceGuaranteeDrawer';
import { type fulfillmentMethodListProps } from '@/apis/dp/floor.interface';
import { getSkuId } from '@/utils/helpers';

export default observer(function BuyOrAddToCar({
  floors,
  serviceData,
  localInfo,
  autoClaimCoupon,
}: any) {
  const searchParams = useSearchParams();
  const { t } = useTranslation();
  const router = useRouter();
  const { productCommonFloor, productBottomBarFloor, productSelectedFloor } = floors;
  const data = productCommonFloor?.data;
  const Basic_data = data?.['C-M#viewCommonItem&commonBasic'];
  const product_data = data?.['C-M#viewCommonItem&commonCore'];
  const selected_data = productSelectedFloor?.data;
  // console.log("============product_data==============", product_data);
  // console.log("============selected_data==============", selected_data);
  const isBigItem = product_data?.isBigItem;
  const displayQty = selected_data?.displayQty;
  const [drawerOpened, setDrawerOpened] = useState<boolean>(false);

  const deliveryInfo_data = data?.deliveryInfo || {};
  const { mainTitle, fulfillmentMethodList } = deliveryInfo_data;
  const isMoreDelivery = fulfillmentMethodList && fulfillmentMethodList?.length > 1;

  const [openDialog, setOpenDialog] = useState(false); //是否开启配送弹窗
  const [shipmentType, setShipmentType] = useState('');

  useEffect(() => {
    let defaultType;
    if (fulfillmentMethodList && fulfillmentMethodList?.length > 1) {
      defaultType = fulfillmentMethodList?.find(
        (item: fulfillmentMethodListProps) => item.selectedStatus,
      )?.shipmentType;
    } else if (fulfillmentMethodList?.length === 1) {
      defaultType = fulfillmentMethodList[0]?.shipmentType;
    }
    setShipmentType(defaultType || '66');
  }, [fulfillmentMethodList]);

  // const [floatHeight, setFloatHeight] = useState<number>();
  const stockValue = Basic_data?.maximumPurchaseLimit || 200;
  const {
    reserveTimeText,
    countdown: reserveCountdown,
    reserveCountText,
    type: buyProductType,
  } = productBottomBarFloor?.data?.unsupportedPurchaseInfo || {};

  const cartuuidRef = useRef<string>('');
  const buyRef = useRef<string>();
  const { serviceListStore, dpStore, cartNumStore } = useStores();
  const { selectedList, getServiceParam } = serviceListStore;
  //loading状态
  const [notifyLoading, setNotifyLoading] = useState(false);
  const [buyNowLoading, setBuyNowLoading] = useState(false);
  const [addCartLoading, setAddCartLoading] = useState(false);

  const { productNumber, setProductNumber } = dpStore;

  const onNotify = () => {
    setNotifyLoading(true);
    OutOfStackController.getInstance().openOutOfStockDialog(
      [product_data.skuId],
      () => {
        router.refresh();
        setNotifyLoading(false);
      },
      () => {
        setNotifyLoading(false);
      },
      () => {
        setNotifyLoading(false);
      },
    );
  };
  // 点击加车处理逻辑
  const handleClickAddCart = () => {
    dpBusinessLogger({
      eventName: DP_EVENT_NAMES.ADD_CART_BUTTON_CLICK,
      message: {
        mainSkuId: product_data.skuId,
        showServiceDialog: BUTTON_TYPE.AddCart,
        isMoreDelivery,
        isBigItem,
        serviceParam: JSON.stringify(getServiceParam?.()),
      },
    });
    if (canShowServiceDialog()) {
      showServiceDialog(BUTTON_TYPE.AddCart);
      return;
    }
    if (isBigItem) {
      addCart(getServiceParam?.());
    } else {
      addCart();
    }
  };
  const addCart = async (serviceParam: {} = {}) => {
    setAddCartLoading(true);
    addCartUtil([{ skuId: product_data.skuId, num: productNumber, ...serviceParam }])
      .then((res) => {
        if (res?.result?.code === '200') {
          gtagAddCartLog([product_data.skuId]);
          // 更新购物车数量
          cartNumStore.updateCartNum(res?.result?.data);
        }
      })
      .finally(() => {
        setAddCartLoading(false);
      });
    sendClickTrack.Productdetail_Addtocart({
      mainskuid: sessionStorage.getItem('initial_skuid') || product_data.skuId,
      skuNum: String(productNumber),
      skuid: getSkuId(searchParams.get('ref_sku'), product_data.skuId),
    });
  };
  // 点击立购处理逻辑
  const handleClickBuyNow = () => {
    dpBusinessLogger({
      eventName: DP_EVENT_NAMES.NOW_BUY_BUTTON_CLICK,
      message: {
        mainSkuId: product_data.skuId,
        showServiceDialog: BUTTON_TYPE.BuyNow,
        isMoreDelivery,
        isBigItem,
        serviceParam: JSON.stringify(getServiceParam?.()),
      },
    });
    // 判断大件服务
    if (canShowServiceDialog()) {
      showServiceDialog(BUTTON_TYPE.BuyNow);
      return;
    }
    //如果有多个配送方式，则打开选择，否则直接结算
    if (isMoreDelivery) {
      setOpenDialog(true);
    } else if (isBigItem) {
      openCheckout(getServiceParam?.());
    } else {
      openCheckout();
    }
  };
  const onBuyNowReq = async ({ addCartParams, autoClaimCouponParams }: any) => {
    const skuId = product_data.skuId;
    setBuyNowLoading(true);
    const data = await AddCart({ refer: 7, ...addCartParams });
    if (data?.code === '200') {
      gtagAddCartLog([product_data.skuId]);
      if (autoClaimCoupon?.enable && autoClaimCouponParams) {
        // 自动领券
        const res = await takeCouponReq(autoClaimCouponParams);
        if (res.code === '200') {
          if (res?.msg) {
            res?.msg &&
              UKToast.show({
                icon: 'success',
                duration: 10000,
                content: res?.msg,
              });
          }
        }
      }
      const url =
        process.env.NODE_ENV === 'development'
          ? `${process.env.NEXT_PUBLIC_FE_TEST_DOMAIN}/checkout`
          : `/checkout`;

      const searchUrl = `?ref=${skuId}&immediatelyBuy=true&shipmentType=${shipmentType}`;
      window.location.href = url + searchUrl;
    } else {
      UKToast.show({
        content: t('common.pageStatus.serverError'),
        icon: 'error',
      });
    }
    setBuyNowLoading(false);
  };
  // 打开结算页
  const openCheckout = async (serviceParam: {} = {}) => {
    let autoClaimCouponParams = null;
    const skuId = product_data.skuId;
    try {
      sendClickTrack.Productdetail_GotoBuyNow({
        mainskuid: sessionStorage.getItem('initial_skuid') || product_data.skuId,
        skuNum: String(productNumber),
        skuid: getSkuId(searchParams.get('ref_sku'), product_data.skuId),
      });
    } catch (err) {}
    const addCartParams = {
      ...serviceParam,
      cartuuid: cartuuidRef.current,
      num: productNumber,
      skuId,
    };
    if (autoClaimCoupon?.enable) {
      // 自动领券
      const takeCouponReqList = autoClaimCoupon?.couponList?.map(
        (item: { ruleId: string; encryptedKey: string }) => ({
          ruleId: item?.ruleId,
          encryptedKey: item?.encryptedKey,
        }),
      );
      if (takeCouponReqList?.length) {
        autoClaimCouponParams = {
          scenario: 1,
          takeCouponReqList,
        };
      }
    }
    const availableParams = { addCartParams, autoClaimCouponParams };
    // 缓存BuyNow 接口参数

    cookieUtil.setSessionStorage('LoginCallBackType.dpBuyNow', availableParams);
    callAfterLoginByUrl(async () => onBuyNowReq(availableParams), {
      type: LoginCallBackType.dpBuyNow,
    });
  };
  // const handleChangeNum = (item: any, num: number) => {
  //   if (!item) {
  //     return;
  //   }
  //   setproductNumber(num);
  // };

  const canShowServiceDialog = () => {
    return (
      isBigItem && !drawerOpened && !selectedList?.length && !!serviceData?.serviceItems?.length
    );
  };

  const showServiceDialog = (btnType: BUTTON_TYPE) => {
    setDrawerOpened(true);
    ServiceController.getInstance().openDrawer({
      title: serviceData?.title,
      serviceData: serviceData,
      btnType: btnType,
      useShareCheck: true,
      addCart: addCart,
      buyNow: openCheckout,
      mainSkuId: product_data.skuId,
      localInfo: localInfo,
    });
  };
  // 开始预约
  const handleClickReserveNow = async () => {
    // 预约
    const res = await reserveReq({ skuId: product_data.skuId });
    if (res?.code === '200') {
      UKToast.show({
        content: res.msg,
        icon: 'success',
      });
      // toast 后 3s 刷新
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      UKToast.show({
        content: res.msg,
        icon: 'error',
      });
    }
  };

  //选择配送方式
  const handleSelectedDelivery = (value: string) => {
    setShipmentType(value);
  };
  const handleCallBackUrl = async () => {
    const url = new URL(window.location.href);
    const isNext = url.searchParams.get('isNext');
    const callbackOptType = url.searchParams.get('callbackOptType');
    if (isNext) {
      if (callbackOptType === LoginCallBackType.dpBuyNow) {
        url.searchParams.delete('callbackOptType');
        url.searchParams.delete('isNext');
        // 更新url, 不会刷新页面
        // window.history.pushState({}, '', url);
        // 用当前URL替换当前历史记录条目（不会创建新记录）

        const reqParamsStr = cookieUtil.getSessionStorage('LoginCallBackType.dpBuyNow');
        if (reqParamsStr) {
          try {
            const params = JSON.parse(reqParamsStr);
            await onBuyNowReq(params);
            window.history.replaceState(null, '', url.pathname + url.search);
          } catch (err) {}
        }
      }
    }
  };

  useEffect(() => {
    cartuuidRef.current = getUserUUIDFromCookie();
    handleCallBackUrl();
  }, []);

  return (
    <>
      {displayQty && (
        <DpCounter selected_data={selected_data} productCommonFloor={productCommonFloor} />
      )}
      {/* 预约提示 */}
      {buyProductType === -6 && reserveTimeText && (
        <ReserveTipsWrapper>
          <div className='tip_text_1'>
            {reserveTimeText} {reserveCountdown && <Countdown countdown={reserveCountdown} />}
          </div>
          <div className='tip_text_2' dangerouslySetInnerHTML={{ __html: reserveCountText }}></div>
        </ReserveTipsWrapper>
      )}
      {/* @ts-ignore */}
      <BuyOrAddToCarWrapper ref={buyRef}>
        {/* 无购物车 */}
        <div className='inner sticky' id='dp_bottom_bar_wrap'>
          <BottomButtonLayout
            data={productBottomBarFloor?.data?.buttons?.primaryBtns}
            btnConfig={{
              [BtnEventIds.notify]: {
                event: onNotify,
                loading: notifyLoading,
              },
              [BtnEventIds.buyNow]: { event: handleClickBuyNow, loading: buyNowLoading },
              [BtnEventIds.addToCart]: { event: handleClickAddCart, loading: addCartLoading },
              [BtnEventIds.reserveNow]: { event: handleClickReserveNow },
            }}
          />
        </div>
      </BuyOrAddToCarWrapper>
      {/* 点击buynow弹出选择配送方式的弹窗 */}
      <ChooseDelivery
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        mainTitle={mainTitle}
        fulfillmentMethodList={fulfillmentMethodList}
        shipmentType={shipmentType}
        handleSelectedDelivery={handleSelectedDelivery}
        openCheckout={() => openCheckout()}
      />
    </>
  );
});
